import _classPrivateFieldLooseBase from "@babel/runtime/helpers/esm/classPrivateFieldLooseBase";
import _classPrivateFieldLooseKey from "@babel/runtime/helpers/esm/classPrivateFieldLooseKey";
import { MagpieConnection } from 'magpie-lib/connection';
import { navVisibilityControls } from 'navigation-messaging/messages';
import { navigationPublicApiTopicDef } from 'navigation-messaging/topics';
import { NAV_DISPLAY_CONFIG_OVERLAY_OPEN_MESSAGE, NAV_DISPLAY_CONFIG_OVERLAY_CLOSE_MESSAGE, NAV_DISPLAY_CONFIG_MODAL_OVERLAY_TYPE } from '../messaging/NavDisplayConfigConstants';
function getTopWindow(window) {
  if (window.parent === window.self) {
    return window;
  }
  return getTopWindow(window.parent);
}
var _instance = /*#__PURE__*/_classPrivateFieldLooseKey("instance");
export class NavInteractions {
  constructor(params) {
    this.TIMEOUT = 10000;
    this.getCurrentVisibility = async () => {
      const topic = MagpieConnection.get().useTopic(navigationPublicApiTopicDef);
      const getVisibility = navVisibilityControls.getNavVisibility.create();
      return new Promise(res => topic.publish(getVisibility, {
        onReply: ({
          payload
        }) => res(payload)
      }));
    };
    this.useNavDisplayConfig = async (config, isOpening) => {
      if (!config) {
        return;
      }
      const topic = MagpieConnection.get().useTopic(navigationPublicApiTopicDef);
      const changeVisibility = navVisibilityControls.changeNavVisibility.create({
        source: this.params.appName,
        shouldShowVerticalNav: config.shouldShowNav,
        shouldShowToolbar: config.shouldShowToolbar
      });
      const visibilityChanged = new Promise(resolve => topic.publish(changeVisibility, {
        onReply: resolve
      }));
      const timeout = new Promise(resolve => setTimeout(() => resolve('timeout'), this.TIMEOUT));
      const result = await Promise.race([visibilityChanged, timeout]);
      if (result === 'timeout') {
        this.fallback(config, isOpening);
      }
    };
    this.fallback = (config, isOpening) => {
      const message = isOpening ? {
        id: NAV_DISPLAY_CONFIG_OVERLAY_OPEN_MESSAGE,
        payload: {
          appName: this.params.appName,
          overlayType: NAV_DISPLAY_CONFIG_MODAL_OVERLAY_TYPE,
          shouldShowToolbar: config ? !!config.shouldShowToolbar : true,
          shouldShowNav: config ? !!config.shouldShowNav : false
        }
      } : {
        id: NAV_DISPLAY_CONFIG_OVERLAY_CLOSE_MESSAGE
      };
      getTopWindow(window).postMessage(message, window.origin);
    };
    this.params = params;
  }
  static getInstance(params) {
    if (!_classPrivateFieldLooseBase(NavInteractions, _instance)[_instance]) {
      _classPrivateFieldLooseBase(NavInteractions, _instance)[_instance] = new NavInteractions(params);
    }
    return _classPrivateFieldLooseBase(NavInteractions, _instance)[_instance];
  }
}
Object.defineProperty(NavInteractions, _instance, {
  writable: true,
  value: void 0
});